import { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar() {
  const { user, logout, hasPermission } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, productName } = useI18n();

  useEffect(() => {
    const el = document.getElementById('navMain');
    if (el && el.classList.contains('show')) {
      document.querySelector('.navbar-toggler')?.click();
    }
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname.startsWith(path) ? 'nav-link active' : 'nav-link';

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/dashboard">
          <i className="bi bi-clock-history me-2" />{productName}
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMain" aria-controls="navMain" aria-expanded="false" aria-label="Menü">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navMain">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className={isActive('/dashboard')} to="/dashboard">{t('nav.dashboard')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/times')} to="/times">{t('nav.times')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/month')} to="/month">{t('nav.month')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/year')} to="/year">{t('nav.year')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/alltime')} to="/alltime">{t('nav.alltime')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/requests')} to="/requests">{t('nav.requests')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/absences')} to="/absences">{t('nav.absences')}</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/calendar')} to="/calendar">{t('nav.calendar')}</Link>
            </li>
            {hasPermission('manage_subordinates') && !hasPermission('manage_users') && (
              <li className="nav-item">
                <Link className={isActive('/admin/users')} to="/admin/users">{t('nav.employees')}</Link>
              </li>
            )}
            {hasPermission('manage_subordinates') && !hasPermission('manage_users') && (
              <li className="nav-item">
                <Link className={isActive('/admin/teams')} to="/admin/teams">{t('nav.teams')}</Link>
              </li>
            )}
            {!hasPermission('manage_users') && ['manage_subordinates', 'manage_schedules', 'view_team_time'].some(hasPermission) && (
              <li className="nav-item">
                <Link className={location.pathname === '/admin' ? 'nav-link active' : 'nav-link'} to="/admin">{t('nav.admin')}</Link>
              </li>
            )}
            {hasPermission('manage_users') && (
              <li className="nav-item dropdown">
                <button type="button" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  {t('nav.admin')}
                </button>
                <ul className="dropdown-menu dropdown-menu-dark">
                  <li><Link className="dropdown-item" to="/admin">{t('nav.adminOverview')}</Link></li>
                  <li><hr className="dropdown-divider" /></li>                  <li><Link className="dropdown-item" to="/admin/users">{t('nav.adminUsers')}</Link></li>
                  <li><Link className="dropdown-item" to="/admin/roles">{t('nav.adminRoles')}</Link></li>
                  <li><Link className="dropdown-item" to="/admin/schedules">{t('nav.adminSchedules')}</Link></li>
                  <li><Link className="dropdown-item" to="/admin/team">{t('nav.adminTeam')}</Link></li>
                  <li><Link className="dropdown-item" to="/admin/teams">{t('nav.adminTeams')}</Link></li>
                  <li><Link className="dropdown-item" to="/admin/company">{t('nav.adminCompany')}</Link></li>
                </ul>
              </li>
            )}
          </ul>
          <div className="navbar-text text-white me-3">
            <i className="bi bi-person-circle me-1" />
            {user?.first_name} {user?.last_name}
            <span className="badge bg-secondary ms-2">{user?.role?.name}</span>
          </div>
          <LanguageSwitcher className="me-3" />
          <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-1" />{t('nav.logout')}
          </button>
        </div>
      </div>
    </nav>
  );
}
